module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, i, j, len, len1, ref, ref1, skill;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.project.get("addSkillsSucceeded")) {
        $o.push("<div class='add-skills-row row-half skills'>\n  <h6 class='as-label'>Skills</h6>");
        ref = this.project.get("skills");
        for (i = 0, len = ref.length; i < len; i++) {
          skill = ref[i];
          $o.push("  <span class='comma'>" + ($e($c(skill))) + "</span>");
        }
        $o.push("</div>");
      } else if (this.skills) {
        $o.push("<form class='maskable' id='add-skills' data-validation='structured' data-projectId='" + ($e($c(this.project.get('id')))) + "'>\n  <input type='hidden' name='project-id' value='" + ($e($c(this.project.get('id')))) + "'>\n  <div class='add-skills-row row-half'>\n    <div class='interaction'>\n      <label class='required-select' for='skill_ids[]'>\n        <div class='required-select-label'>Skills</div>\n        <select class='js-skills-input select2-hidden-accessible' name='skill_ids[]' aria-hidden='true' required data-parsley-required-message='Please select at least one skill.' data-behavior='select2' data-select2options='{\"placeholder\": \"Select up to 3 skills you used to complete this project.\", \"maximumSelectionLength\": 3 }' multiple tabindex='-1'>");
        ref1 = this.skills;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          skill = ref1[j];
          $o.push("          <option value='" + ($e($c(skill.id))) + "' selected='" + ($e($c(this.project.get("skill_ids").indexOf(skill.id) >= 0))) + "'>" + ($e($c(skill.name))) + "</option>");
        }
        $o.push("        </select>\n      </label>\n    </div>");
        if (this.project.get("addSkillsSucceeded") === false) {
          $o.push("    <div class='add-skills-fail subtext'>Failed to add skills, please try again</div>");
        }
        $o.push("  </div>\n</form>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/add_skills.js.hamlc
// module id = 1321
// module chunks = 17